var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5251 14.7764C10.9254 14.7764 10.4281 14.2791 10.4281 13.6793V13.3722C10.4281 11.6755 11.6714 10.8417 12.1395 10.5199C12.6807 10.1542 12.8562 9.90554 12.8562 9.52523C12.8562 8.79387 12.2565 8.1941 11.5251 8.1941C10.7938 8.1941 10.1941 8.79387 10.1941 9.52523C10.1941 10.125 9.69677 10.6223 9.09705 10.6223C8.49733 10.6223 8 10.125 8 9.52523C8 7.5798 9.57971 6 11.5251 6C13.4706 6 15.0503 7.5798 15.0503 9.52523C15.0503 11.1927 13.8216 12.0265 13.3682 12.3337C12.7977 12.714 12.6222 12.9627 12.6222 13.3722V13.6793C12.6222 14.2937 12.1249 14.7764 11.5251 14.7764Z",
    fill: "#4E4B66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5267 18.4186C10.9124 18.4186 10.4297 17.9213 10.4297 17.3215C10.4297 16.7218 10.927 16.2245 11.5267 16.2245C12.1265 16.2245 12.6238 16.7218 12.6238 17.3215C12.6238 17.9213 12.1411 18.4186 11.5267 18.4186Z",
    fill: "#4E4B66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.38047 24 0 18.6195 0 12C0 5.38047 5.38047 0 12 0C18.6195 0 24 5.38047 24 12C24 18.6195 18.6195 24 12 24ZM12 1.67442C6.30698 1.67442 1.67442 6.30698 1.67442 12C1.67442 17.693 6.30698 22.3256 12 22.3256C17.693 22.3256 22.3256 17.693 22.3256 12C22.3256 6.30698 17.693 1.67442 12 1.67442Z",
    fill: "#4E4B66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.df5a316e0043a53ca38601434bdc2d58.svg";
export { ForwardRef as ReactComponent };